import { DataTable } from "@/components/admin/data-table";
import { DateField } from "@/components/admin/date-field";
import { List } from "@/components/admin/list";
import { ListPagination } from "@/components/admin/list-pagination";
import { CreateButton } from "@/components/admin/create-button";
import { ExportButton } from "@/components/admin/export-button";
import { FilterButton } from "@/components/admin/filter-form";
import { NumberField } from "@/components/admin/number-field";
import { ReferenceField } from "@/components/admin/reference-field";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SearchInput } from "@/components/admin/search-input";
import { SelectInput } from "@/components/admin/select-input";
import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { ToggleFilterButton } from "@/components/admin/toggle-filter-button";
import { TopToolbar } from "../../layout/TopToolbar";
import { TransactionDirectionBadge } from "../shared/TransactionDirectionBadge";
import { transactionDirectionChoices } from "../shared/transactionModel";
import type { Transaction } from "../../types";

const transactionFilters = [
  <SearchInput source="q" alwaysOn />,
  <SelectInput
    source="direction"
    choices={transactionDirectionChoices}
    label="resources.transactions.fields.direction"
  />,
  <ReferenceInput source="account_id" reference="accounts">
    <AutocompleteInput label="resources.transactions.fields.account_id" />
  </ReferenceInput>,
  <ReferenceInput source="category_id" reference="transaction_categories">
    <AutocompleteInput label="resources.transactions.fields.category_id" />
  </ReferenceInput>,
];

export const TransactionList = () => (
  <List
    sort={{ field: "occurred_at", order: "DESC" }}
    filters={transactionFilters}
    actions={<TransactionActions />}
    pagination={<ListPagination rowsPerPageOptions={[25, 50, 100]} />}
  >
    <div className="mb-3 flex flex-wrap gap-2">
      <ToggleFilterButton
        label="resources.transactions.directions.income"
        value={{ direction: "income" }}
        className="w-auto"
      />
      <ToggleFilterButton
        label="resources.transactions.directions.expense"
        value={{ direction: "expense" }}
        className="w-auto"
      />
    </div>
    <DataTable<Transaction> rowClick="show">
      <DataTable.Col source="occurred_at" field={DateField} />
      <DataTable.Col
        source="direction"
        render={(r) => (
          <TransactionDirectionBadge
            direction={r.direction}
            isTransfer={!!r.transfer_id}
          />
        )}
      />
      <DataTable.Col source="amount">
        <NumberField source="amount" />
      </DataTable.Col>
      <DataTable.Col source="account_id">
        <ReferenceField source="account_id" reference="accounts" link={false} />
      </DataTable.Col>
      <DataTable.Col source="category_id">
        <ReferenceField
          source="category_id"
          reference="transaction_categories"
          link={false}
        />
      </DataTable.Col>
      <DataTable.Col source="description" />
    </DataTable>
  </List>
);

const TransactionActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
    <CreateButton label="resources.transactions.action.new" />
  </TopToolbar>
);
